<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'moi.incidentSummary.cardTitle' | transloco }}</div>
    @if (summaryModel) {
        <div class="detail-page-card-actions">
            @if (summaryModel.canOpenParent) {
                <button class="btn btn-raised" (click)="openIncident()">
                    <i class="fas fa-external-link-alt"></i>
                    <span>{{ 'moi.incidentSummary.openIncidentBtn' | transloco }}</span>
                </button>
            }
        </div>
    }

    <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
        @if (summaryModel) {
            <div class="row">
                <div class="col-12 col-xl-6 left-block">
                    <div class="row">
                        <div class="col-3">
                            <div class="form-group">
                                <label>{{ 'moi.incidentSummary.identifierLabel' | transloco }}</label>
                                <input
                                    data-uiid="incident-moi-identifier"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="summaryModel.identifier"
                                    inputTooltip
                                />
                            </div>
                        </div>
                        <div class="col-9">
                            <div class="form-group">
                                <label>{{ 'moi.incidentSummary.incidentNameLabel' | transloco }}</label>
                                <input
                                    data-uiid="incident-moi-name"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="summaryModel.name"
                                    inputTooltip
                                />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'moi.incidentSummary.dateOccurredLabel' | transloco }}</label>
                                <date-input
                                    data-uiid="incident-moi-dateoccurred"
                                    [(value)]="summaryModel.date_Occurred"
                                    [disabled]="true"
                                ></date-input>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'moi.incidentSummary.dateDetectedLabel' | transloco }}</label>
                                <date-input
                                    data-uiid="incident-moi-datedetected"
                                    [(value)]="summaryModel.date_Detected"
                                    [disabled]="true"
                                ></date-input>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-xl-6 right-block">
                    <div class="form-group">
                        <label>{{ 'moi.incidentSummary.descriptionLabel' | transloco }}</label>
                        <textarea
                            data-uiid="incident-moi-description"
                            class="form-control form-control-sm"
                            disabled
                            [rows]="5"
                            [value]="summaryModel.description"
                            inputTooltip
                        ></textarea>
                    </div>
                </div>
            </div>
        } @else {
            <div class="fancy-loader submodule my-4"></div>
        }
    </div>
</div>
